import { Box, Link, Paper, Stack, TextField, Typography } from '@mui/material'
import { FunctionComponent, useMemo } from 'react'
import { Link as RouterLink } from 'react-router-dom'

import { AppRoutes } from '../../models'
import { RepairOrderExpanded, VehicleEntry, VehicleImageEntry } from '../../sdk'
import { describeVehicle } from '../../utils'

interface Props {
  disableLink?: boolean
  repairOrder: RepairOrderExpanded
  vehicle: VehicleEntry
  vehicleImages: VehicleImageEntry[]
  horizontal?: boolean
}

const VehicleInfoBox: FunctionComponent<Props> = ({
  disableLink,
  repairOrder,
  vehicle,
  vehicleImages,
  horizontal
}) => {
  const mileageIn = repairOrder?.entry!.info!.mileageIn || 'N/A'
  const mileageOut = repairOrder?.entry!.info!.mileageOut || 'N/A'
  const activeVehicleImage = useMemo(() => {
    return vehicleImages?.find((vehicleImage) => vehicleImage.info?.isPrimary)
  }, [vehicleImages])

  const vehicleDescription = (
    <Typography component="h3" variant="h4">
      {describeVehicle(vehicle.info!)}
    </Typography>
  )

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2
      }}>
      <Stack direction={horizontal ? 'row' : 'column'} spacing={2}>
        {activeVehicleImage && (
          <Box>
            <img
              src={activeVehicleImage.info?.vehicleImageURL}
              alt="Vehicle Image"
              style={{
                maxWidth: '100%',
                maxHeight: '100%'
              }}
            />
          </Box>
        )}
        {vehicle && (
          <Stack direction="column" spacing={1}>
            {disableLink ? (
              vehicleDescription!
            ) : (
              <Link
                component={RouterLink}
                to={AppRoutes.VEHICLES + '/' + vehicle.id!}>
                {vehicleDescription!}
              </Link>
            )}
            {vehicle.info!.licensePlate ? (
              vehicle.info!.registeredState ? (
                <TextField
                  label="License Plate"
                  variant="standard"
                  disabled
                  InputProps={{ disableUnderline: true }}
                  defaultValue={`${vehicle.info!.licensePlate} - ${
                    vehicle.info!.registeredState
                  }`}
                />
              ) : (
                <TextField
                  label="License Plate"
                  variant="standard"
                  disabled
                  InputProps={{ disableUnderline: true }}
                  defaultValue={vehicle.info!.licensePlate}
                />
              )
            ) : (
              <TextField
                label="License Plate"
                variant="standard"
                disabled
                InputProps={{ disableUnderline: true }}
                defaultValue="N/A"
              />
            )}
            <TextField
              label="VIN"
              variant="standard"
              disabled
              InputProps={{ disableUnderline: true }}
              defaultValue={vehicle.info!.vin || 'N/A'}
            />
            {mileageIn && (
              <TextField
                label="Mileage In"
                variant="standard"
                disabled
                InputProps={{ disableUnderline: true }}
                defaultValue={mileageIn}
              />
            )}
            {mileageOut && (
              <TextField
                label="Mileage Out"
                variant="standard"
                disabled
                InputProps={{ disableUnderline: true }}
                defaultValue={mileageOut}
              />
            )}
          </Stack>
        )}
      </Stack>
    </Paper>
  )
}

export default VehicleInfoBox
